// extracted by mini-css-extract-plugin
export default {"container":"style_container__JCnHq","title":"style_title__LXmho","desc":"style_desc__yjjDb","subtitle":"style_subtitle__ViBCA"};